export enum AuthViews {
  LOGIN = 'logIn',
  CREATE = 'create',
  FORGOT = 'forgot',
  RESET_PASSWORD = 'resetPassword',
}

export enum InputKeys {
  FIRST_NAME = 'firstName',
  LAST_NAME = 'lastName',
  EMAIL = 'username',
  PHONE_NUMBER = 'phoneNumber',
  PASSWORD = 'password',
  PASSWORD_CONFIRMATION = 'passwordConfirmation',
  MARKETING_EMAILS = 'emailSubscribe',
  MARKETING_SMS = 'smsSubscribe',
  TERMS = 'terms',
  CONFIRMATION_CODE = 'confirmation_code',
  REMEMBER_ME = 'rememberMe',
}

export const initialValues = {
  [AuthViews.LOGIN]: {
    [InputKeys.EMAIL]: '',
    [InputKeys.PASSWORD]: '',
    [InputKeys.REMEMBER_ME]: true,
  },
  [AuthViews.CREATE]: {
    [InputKeys.FIRST_NAME]: '',
    [InputKeys.LAST_NAME]: '',
    [InputKeys.EMAIL]: '',
    [InputKeys.PHONE_NUMBER]: '',
    [InputKeys.PASSWORD]: '',
    [InputKeys.PASSWORD_CONFIRMATION]: '',
    [InputKeys.MARKETING_EMAILS]: true,
    [InputKeys.MARKETING_SMS]: false,
    [InputKeys.TERMS]: false,
  },
  [AuthViews.FORGOT]: {
    [InputKeys.EMAIL]: '',
  },
  [AuthViews.RESET_PASSWORD]: {
    [InputKeys.EMAIL]: '',
    [InputKeys.PASSWORD]: '',
    [InputKeys.PASSWORD_CONFIRMATION]: '',
    [InputKeys.CONFIRMATION_CODE]: '',
  },
};
// Must include at least 1 number, 1 uppercase letter and 1 special character (i.e. !@#$%^&*). 8-25 characters.
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/;

export const contentDefaults = {
  [AuthViews.LOGIN]: {
    header: {
      title: 'Log in',
    },
    footer: {
      title: 'Create Account',
      goTo: 'create',
    },
  },
  [AuthViews.CREATE]: {
    header: {
      title: 'Create an Account',
      subtitle: 'Do More with a Traeger Account',
      description: 'Get free access to recipes, repeat orders, and free shipping on pellets.',
    },
    footer: {
      title: 'Log In',
      text: 'Already have an account?',
      goTo: 'logIn',
    },
  },
  [AuthViews.FORGOT]: {
    header: {
      title: 'Forgot your password?',
      subtitle: '',
      description:
        'If there is an account associated with this email, we will send you a link to reset your password.',
    },
    footer: {
      title: 'Log In',
      text: 'Remember your password?',
      goTo: 'logIn',
    },
  },
  [AuthViews.RESET_PASSWORD]: {
    header: {
      title: 'Reset password email sent!',
      subtitle: '',
      description:
        'In the next few minutes, you will receive an email with a verification code to reset your password.',
    },
    footer: {
      title: 'Request a code',
      text: 'Need a new code?',
      goTo: 'forgot',
    },
  },
};
